import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'gb-google-icon',
  templateUrl: './gb-google-icon.component.html',
  styleUrls: ['./gb-google-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbGoogleIconComponent {}
